import { Input, FormGroup, Label, Row, Col, Table } from "reactstrap";
import { useContext } from "react";
import DataTableNested from "../../../components/DataTableNested";
import { QuoteDataContext } from "../contexts/quoteDataContext";
import Collapsable from "../../../components/Collapsable";

const QuoteReviewErrorsTable = ({
    errors,
    header
}) => {
    const quoteDataContext = useContext(QuoteDataContext);

    const columns = [
        {
            /* THIS IS THE FIELD USED FOR COLLAPSABLE SECTIONS IN TABLE */
            key: "error",   
            label: "Error",
            style: { width: "350px" },
            render: (value, row, isExpanded, hasChildren) => {
                if (!hasChildren) return null;

                return (
                    <div style={{display: "block"}}>
                        <Row className="align-items-center">
                            <Col xs="auto">
                                <i className="bi bi-x-circle text-danger"></i> 
                            </Col>
                            <Col className="p-0">
                                <strong>{value || ""}</strong><br></br>   
                                <span className="text-muted">&nbsp;{`(${row.items.length} items)`}</span>
                            </Col>
                        </Row>
                    </div>
                );
            }
        },
        {
            key: "detail",
            label: "Detail",
            render: (value, row, isExpanded, hasChildren) => {
                return (
                    value
                )
            }
        }
    ].map(col => ({
        // Add default styles for all columns here
        ...col,
        align: "left"
    })) 

    const stats = {
        totalErrors: errors.flatMap(w => w.items).length
    };

    const sectionHeaderWithStats = `${(header ?? "Errors")} (${stats.totalErrors} total)`;

    return (
        <Collapsable header={errors.length > 0 ? sectionHeaderWithStats : header + " (None)"} open={errors.length > 0} fluid>
            <>
                {errors.length === 0 &&
                    <div>No errors</div>
                }
                {(errors.length > 0) && (
                    <DataTableNested
                        id="quote-review-errors-table"
                        columns={columns}
                        data={errors}
                        width="100%"
                    />            
                )}
            </>
        </Collapsable>
    );
}
export default QuoteReviewErrorsTable;